import React from "react";
import clsx from "clsx";
import {CmsSection} from "@lib/Cms/CmsModels";
import {NavLink} from "react-router-dom";
import {buildLinkUrl} from "@router/RouterUtils";
import {ChevronRightIcon} from "@components/Icons/ChevronRightIcon";

interface PreFooterProps {
    cms: CmsSection;
    className?: string;
}

const PreFooter = ({cms, className}: PreFooterProps) => {

    if (!cms.title && !cms.text) {
        return null
    }

    const c = clsx([
        "pre-footer",
        cms.options?.variant ?? "default",
        className
    ]);

    const ctaCms = cms.cta?.[0];

    return (
        <div className={c}>
            <div className="pre-footer__content">
                <div className="pre-footer-contact">
                    <div className="pre-footer-contact__main">
                        {!!cms.title &&
                            <h2 className={"tp-2xl semibold"} dangerouslySetInnerHTML={{__html: cms.title}}/>
                        }
                        {cms.text &&
                            <p className={"tp-m light"} dangerouslySetInnerHTML={{__html: cms.text}}/>
                        }
                    </div>

                    {!!ctaCms &&
                        <div className={"pre-footer-contact__actions"}>
                            <NavLink to={buildLinkUrl(ctaCms.scope)} className={"cta cta--medium"}>
                            <span className="label">
                                {ctaCms.title}
                            </span>
                                <span className="icon">
                                <ChevronRightIcon/>
                            </span>
                            </NavLink>
                        </div>
                    }

                </div>
            </div>
        </div>
    );

}

export default PreFooter;